import { Button, Card, Grid, Header } from 'semantic-ui-react'
import React, { Component } from 'react'
import CloudinaryPicSet from '../components/CloudinaryPicSet'
import Expandable from '../components/Expandable'
import PropTypes from 'prop-types'
import _ from 'lodash'

function BusinessdKnowledge() {
	const areas = [
		{
			title: 'Leadership',
			details: 'Vision, education, passion'
		},
		{
			title: 'Management',
			details: 'Scheduling, project organization, processes'
		},
		{
			title: 'Legal',
			details:
				'Contract drafting, agreement strategy, statute research (Note: I am not a lawyer)'
		},
		{
			title: 'Accounting & Bookkeeping',
			details: 'Quickbooks accounts from scratch and bookkeeping as needed'
		},
		{
			title: 'Spreadsheets',
			details: [
				'Google Spreadsheets from basic formulas and graphs up to validation, pivot tables and scripting',
				'Open Office & Excel as needed'
			]
		},
		{
			title: 'Marketing',
			details: [
				'Concepts like phrasing, appearance, customer perspective, price anchoring',
				'Tools like Yelp, Craigslist, SEO, PPC'
			]
		},
		{
			title: 'Sales',
			details: 'Lead generation to calls and follow up processes'
		},
		{
			title: 'Social media',
			details: 'Connecting with customers on platforms like Facebook & Twitter'
		},
		{
			title: 'Information Technology',
			details:
				'Areas such as computer hardware repair, networking, and general software use'
		},
		{
			title: 'Copywriting',
			details: 'Customer perspective, grammar, localities, persuasive arguments'
		}
	].map(a => {
		a.details = _.isArray(a.details) ? a.details : [a.details]
		return a
	})
	return (
		<div>
			<Header as="h3">
				<Header.Content>
					I&#39;ve learned a little of everything running my own small consulting firms
					<Header.Subheader>
						When freelancing I usually focus on development while my wider insights help
						communication and technical descisions
					</Header.Subheader>
				</Header.Content>
			</Header>
			<Grid textAlign="center" columns="3" stackable>
				{areas.map(area => (
					<Grid.Column key={area.title}>
						<Header as="h4">
							<Header.Content>{area.title}</Header.Content>
						</Header>
						{area.details.map((d, ii) => <p key={ii}>{d}</p>)}
					</Grid.Column>
				))}
			</Grid>
		</div>
	)
}
function Personality() {
	function Books(props) {
		return (
			<div>
				<Header as="h4" textAlign="center" className="books-header">
					{props.title}
				</Header>

				<Card.Group className="book-set">
					{props.books.map(thing => (
						<Card key={thing.title}>
							<Card.Content>
								<a href={thing.link} target="anthony-book">
									<CloudinaryPicSet
										className="ui mini left floated image"
										alt={thing.title}
										filename={`anthony.astige.com/book-covers/${thing.image}`}
										defaultWidth={70}
										widths={[140, 70, 35]}
										ext="jpg"
									/>
									{thing.title}
								</a>
							</Card.Content>
						</Card>
					))}
				</Card.Group>
			</div>
		)
	}
	Books.propTypes = {
		title: PropTypes.string.isRequired,
		books: PropTypes.arrayOf(
			PropTypes.shape({ title: PropTypes.string, link: PropTypes.string })
		).isRequired
	}
	const books = [
		{
			title: 'Behavior-driven development for the whole software lifecycle',
			link: 'https://smile.amazon.com/gp/product/161729165X',
			image: 'behaviorDrivenDevelopment'
		},
		{
			title: 'Essentials of Strength Training and Conditioning',
			link: 'https://smile.amazon.com/gp/product/0736058036',
			image: 'strengthTrainingAndConditioning'
		},
		{
			title: 'Starting Strength: Basic Barbell Training',
			link: 'https://smile.amazon.com/gp/product/0982522738',
			image: 'startingStrength'
		},
		{
			title: 'Logically Fallacious: The Ultimate Collection ...',
			link: 'https://smile.amazon.com/gp/product/1456607529',
			image: 'logicallyFallacious'
		},
		{
			title: 'Business Contracts : Turn Any Business Contract ...',
			link: 'https://smile.amazon.com/gp/product/1599180723',
			image: 'businessContracts'
		},
		{
			title: 'Business Model Generation: A Handbook for Visionaries, ...',
			link: 'https://smile.amazon.com/gp/product/0470876417',
			image: 'businessModelGeneration'
		},
		{
			title: 'Eat, Drink, and Be Healthy: The Harvard ...',
			link: 'https://smile.amazon.com/gp/product/0743266420',
			image: 'eatDrinkAndBeHealthy'
		},
		{
			title: 'Stretching Scientifically: A Guide to Flexibility Training',
			link: 'https://www.amazon.com/gp/product/0940149451',
			image: 'stretchingScientifically'
		},
		{
			title: 'Flow: The Psychology of Optimal Experience',
			link: 'https://smile.amazon.com/gp/product/0060920432',
			image: 'flow'
		}
	]
	const things = [
		{
			title: 'Focused',
			description: (
				<p>
					I use a personal{' '}
					<a target="_new" href="http://gettingthingsdone.com/">
						Getting Things Done
					</a>{' '}
					and{' '}
					<a target="_new" href="http://www.43folders.com/izero">
						inbox zero
					</a>{' '}
					system to maximize my time in{' '}
					<a target="_new" href="https://en.wikipedia.org/wiki/Flow_(psychology)">
						flow
					</a>.
				</p>
			)
		},
		{
			title: 'Learner',
			description: (
				<p>
					I&#39;m a life long learner constantly picking up new tech or otherwise both on
					the job and off.
				</p>
			)
		},
		{
			title: 'Role filler',
			description: (
				<p>
					Among many roles, sometimes I&#39;m a brainstorming executive letting ideas
					flow, an engineer looking for potential pitfalls, or a worker with tunnel vision
					getting things done.
				</p>
			)
		},
		{
			title: 'Logical & emotionally aware',
			description: (
				<p>
					I find it helpful to make choices on real data when I can, follow my gut when I
					have to move quickly, and work around or get over emotionally difficult
					situations when needed (e.g.; depersonalizing criticism).
				</p>
			)
		},
		{
			title: 'Balanced',
			textAlign: 'center',
			description: (
				<div>
					<p>
						I believe taking care of my body and emotions keeps my intellect sharp. I keep
						a work-life balance by hiking, traveling, working out, and spending time with
						my family.
					</p>
				</div>
			)
		}
	]
	return (
		<div>
			<Header as="h3">
				<Header.Content>
					I work hard, smart, &amp; fast
					<Header.Subheader>Harder, Better, Faster, Stronger, ...</Header.Subheader>
				</Header.Content>
			</Header>
			<Grid columns="2" centered>
				{things.map(thing => (
					<Grid.Column key={thing.title} textAlign={thing.textAlign}>
						<Header as="h4">
							<Header.Content>{thing.title}</Header.Content>
						</Header>
						{thing.description}
					</Grid.Column>
				))}
			</Grid>
			<Books title="Some books I've read" books={books} />
		</div>
	)
}

export default class AboutMeSection extends Component {
	constructor() {
		super()
		this.state = {}
	}

	render() {
		return (
			<div>
				<Header as="h2">
					I&#39;m a full stack JavaScript web app &amp; software developer with some
					extras
				</Header>

				<Expandable buttonText="Business Knowledge">
					<BusinessdKnowledge />
				</Expandable>

				<Expandable buttonText="Personality">
					<Personality />
				</Expandable>

				<Button as="a" href="/resume/" rel="noopener noreferrer" target="_blank" primary>
					Resume
				</Button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/AboutMeSection.js